export interface DeprecatedBadgeProps {
  renderRoot?: HTMLElement
  size?: 'small' | 'medium'
  showDot?: boolean
  text?: string
  type?: 'default' | 'emphasis' | 'error' | 'info' | 'muted' | 'primary' | 'success' | 'warning'
  [x: string]: unknown
}
